var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resp_mid_nav_wrap"},[_c('div',{class:`resp_mid_nav_outer${_vm.menuMobile ? ' active' : ''}`},[_c('a',{class:`responsive_nav resp_mid_nav${_vm.menuMobile ? ' active' : ''}`,attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onToggle()}}},[_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }